import React from 'react';
import { Button } from './ui/button';
import { Check } from 'lucide-react';
import { services } from '../data/mock';
import { stripDiacritics } from '../lib/utils';

const Services = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="servicios" className="py-24 bg-[#0A192F]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#F2F2F2] mb-4">
            Nuestros <span className="text-[#FFD700]">Servicios</span>
          </h2>
          <p className="text-lg text-[#F2F2F2]/80 max-w-3xl mx-auto">
            Soluciones completas de protección solar para cada necesidad
          </p>
        </div>

        <div className="space-y-16">
          {services.map((service, index) => (
            <div
              key={service.id}
              className={`flex flex-col ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } gap-8 items-center bg-[#F2F2F2]/5 rounded-2xl overflow-hidden hover:bg-[#F2F2F2]/10 transition-colors p-8`}
            >
              <div className="lg:w-1/2 w-full">
                <div className="w-full h-80 rounded-lg overflow-hidden shadow-xl">
                  <img
                    src={service.image}
                    alt={stripDiacritics(service.title)}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="lg:w-1/2 space-y-6">
                <div className="inline-block px-4 py-1 bg-[#FFD700]/20 rounded-full">
                  <span className="text-[#FFD700] font-semibold">Servicio {service.id}</span>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-[#F2F2F2]">{service.title}</h3>
                <p className="text-[#F2F2F2]/80 leading-relaxed">{service.description}</p>
                <ul className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <Check className="w-5 h-5 text-[#FFD700] flex-shrink-0 mt-1" />
                      <span className="text-[#F2F2F2]/90">{feature}</span>
                    </li>
                  ))}
                </ul>
                <Button
                  onClick={scrollToContact}
                  className="bg-[#FFD700] text-[#0A192F] hover:bg-[#FFD700]/90 font-semibold px-8 py-6"
                >
                  Solicitar presupuesto
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
